import { TaskGroupTasksChoiceComponent } from './task-group-tasks-choice.component';

export const TaskGroupTasksChoiceModule = angular
  .module('sfMobile.task-group-tasks-choice', [
    'sfMobile.services.localization',
    'sfMobile.services.tasks',
  ])
  .component('sfTaskGroupTasksChoice', TaskGroupTasksChoiceComponent).name;
